window.toggleFilter = (el, id) => {
    const selectField = $('#' + id);

    if ($(el).is(':checked')) {
        selectField.slideDown();

        return;
    }

    selectField.slideUp();
    selectField.find('select').val([]).change();

    window['redraw' + $(el).data('chart-name')]();
}

const TCIR = $('#TCIR');
const LTIR = $('#LTIR');
const LWDR = $('#LWDR');
const DART = $('#DART');
const TRIFR = $('#TRIFR');
const LTIFR = $('#LTIFR');
const SEVERITY = $('#SEVERITY');
const TRSR = $('#TRSR');

const KPIs = [TCIR, LTIR, LWDR, DART, TRIFR, LTIFR, SEVERITY, TRSR];

window.safetyCalculatorChanged = () => {
    KPIs.forEach(function (kpi) {
        const val = rand(1, 100);
        const className = 'alert-' + getClassBasedOnValue(val);

        kpi.find('span').html(val);
        kpi.removeClass('alert-danger alert-warning alert-success').addClass(className);
    });
}

window.saveCalculatedValues = () => {
    KPIs.forEach(function (kpi) {
        const el = $('#value' + kpi.attr('id'));
        const val = kpi.find('span').html();
        const className = 'bg-' + getClassBasedOnValue(val);

        el.find('.class-code').removeClass('bg-danger bg-warning bg-success').addClass(className);
        el.find('.value').html(kpi.find('span').html());
    });

    $('.toast').toast('show');
}

function getClassBasedOnValue(val) {
    return val > 70
        ? 'danger'
        : val > 40
            ? 'warning'
            : 'success';
}
